"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarEdit = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const rn_css_1 = __importStar(require("rn-css"));
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const base_ui_elements_icon_1 = require("@unboared/base-ui.elements.icon");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const design_player_avatar_1 = require("@unboared/design.player.avatar");
function AvatarEdit({ name, color, size = design_player_avatar_1.DEFAULT_AVATAR_SIZE, onPress }) {
    const theme = (0, rn_css_1.useTheme)();
    const currentTheme = theme || base_ui_theme_themes_1.unboaredDarkTheme;
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: onPress },
        react_1.default.createElement(design_player_avatar_1.Avatar, { name: name, color: color, size: size }),
        react_1.default.createElement(EditIcon, { color: color, borderColor: currentTheme.backgroundColor, textColor: currentTheme.buttonTextColor, size: size / 5 })));
}
exports.AvatarEdit = AvatarEdit;
const EditIcon = ({ color, borderColor, textColor, size }) => {
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    return (react_1.default.createElement(EditIconContainer, { backgroundColor: color, borderColor: borderColor, size: size, normalize: normalize },
        react_1.default.createElement(base_ui_elements_icon_1.Icon, { name: "edit", color: textColor, size: size })));
};
const EditIconContainer = rn_css_1.default.View `
    position:absolute;
    padding : ${props => props.normalize(props.size / 3)};
    top:${props => -props.normalize(0.9 * props.size)};
    right:${props => -props.normalize(0.7 * props.size)};
    background-color : ${props => props.backgroundColor};
    border: ${props => props.normalize(props.size / 5)} solid ${props => props.borderColor};
    border-radius : 100%;
`;
//# sourceMappingURL=avatar_edit.js.map